import BaseModel from "../../BaseModal"
import { getDateWithTime } from "../../utils";
import { FlexWrapperCenter, GapView, LineView } from "../../styles/WrapperStyles";
import styled, { css } from "styled-components";
import './Modal.css';

const ParentDiv = styled.div`
  width: 1100px;
  height: 339px;
  border-radius: 20px;
`;

const TextView = styled.p`
  font-family: 'Gilory-Semi';
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #484848;
  text-align: center;
  ${props =>
        props.small &&
        css`
      font-size: 16px;
    `}
`;

const TitleView = styled.div`
  font-family: 'Gilroy-Bold';
  font-size: 20px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #484848;
  text-align: center;
`;

const aisleReasonMap = {
    0: '',
    1: 'Bad Actor',
    2: 'Disabled for Blocks',
    3: 'Disabled for Multiple Connections',
    4: 'Inappropriate Images',
    5: 'Disabled for Multiple Requests',
    6: 'Disabled for Location Changes',
    7: 'Scammer',
    8: 'Solicitor/Sus',
    9: 'Impersonation',
    10: 'Abusive/Vulgar messages',
    11: 'Many reports',
    12: 'Inappropriate BIOS',
    13: 'Explicit images',
    14: 'Married',
    15: 'Rooted Device',
    16: 'Location banned',
    17: 'Phonecode banned',
    18: 'Banned Credentials',
    19: 'Banned Email Domain',
    20: 'Phone number in bio/icebreaker',
    21: 'Location disabled'
};

const vernacsReasonMap = {
    0: '',
    1: 'Bad Actor',
    2: 'Disabled for Blocks',
    3: 'Disabled for Blocking',
    4: 'Disabled for Connections',
    5: 'Blocks',
    6: 'Inappropriate Images',
    7: 'Multiple Requests',
    8: 'Bad Images',
    9: 'Scammer',
    10: 'Solicitor/Sus',
    11: 'Impersonation',
    12: 'Abusive/Vulgar messages',
    13: 'Many reports',
    14: 'Inappropriate BIOS',
    15: 'Explicit images',
    16: 'Married',
    17: 'Rooted Device',
    18: 'Location banned',
    19: 'Phonecode banned',
    20: 'Phone number in bio/icebreaker',
    21: 'Banned Credentials',
    22: 'Banned Email Domain',
    23: 'Location disabled'
};

const reasonStringMap = {
    'is_scammer': 'Scammer',
    'is_suspicious_or_solicitor': 'Solicitor/Sus',
    'is_impersonation': 'Impersonation',
    'is_abusive_or_vulgar': 'Abusive/Vulgar messages',
    'is_many_reports': 'Many reports',
    'is_inappropriate_bios': 'Inappropriate BIOS',
    'is_explicit_images': 'Explicit images',
    'is_married': 'Married',
    'is_device_rooted': 'Rooted Device',
    'is_location_banned': 'Location banned',
    'is_phonecode_banned': 'Phonecode banned',
    'banned_credentials': 'Banned Credentials',
    'banned_email_domain': 'Banned Email Domain',
    'ban_for_blocks': 'Blocks',
    'ban_for_inappropriate_images': 'Inappropriate Images',
    'bad_actor_for_blocked': 'Bad Actor',
    'disabled_for_blocks': 'Disabled for Blocks',
    'disabled_for_blocking': 'Disabled for Blocking',
    'disabled_for_connections': 'Disabled for Connections',
    'multiple_request': 'Multiple Requests',
    'disable_for_bad_images': 'Bad Images',
    'blocked_profiles': 'Bad Actor',
    'received_blocks': 'Disabled for Blocks',
    'multiple_connections': 'Disabled for Multiple Connections',
    'multiple_inappropriates': 'Inappropriate Images',
    'multiple_request_sent': 'Disabled for Multiple Requests',
    'multiple_location_change': 'Disabled for Location Changes',
    'phone_number_in_bio_or_icebreaker': 'Phone number in bio/icebreaker',
    'is_location_disabled': 'Location disabled',
    'hive_image_update_images': 'Hive image update → Images (manual review)',
    'hive_image_update_updates': 'Hive image update → Updates (manual review)',
    'hive_image_update_auto_updates_images': 'Hive image update → Auto Updates',
    'hive_image_update_people': 'Hive image update → People (manual review)',
    'hive_image_update_failed': 'Hive image update → Manual review (Hive incomplete)'
};

const ProfileStateListModal = (props) => {
    const stateHistory = props.profile?.profile_data?.profile_states_history ||
                        props.profile?.state_history_list || [];
    const appName = localStorage.getItem('appName');
    const isVernacsApp = ['Arike', 'Anbe', 'HeyDil', 'Neetho', 'Neene'].includes(appName);
    const reasonMap = isVernacsApp ? vernacsReasonMap : aisleReasonMap;

    const getDisplayReason = (item) => {
        const stringReason = item.reason;
        if (stringReason && stringReason !== 'not_available' && stringReason !== 'not available') {
            return reasonStringMap[stringReason] || stringReason;
        }

        const numericReason = item.reason_for_change;
        const mappedReason =
            reasonMap[numericReason] ||
            reasonStringMap[numericReason] ||
            numericReason;

        if (!mappedReason) return '';
        if (mappedReason === 'not_available' || mappedReason === 'not available') return '';
        if (mappedReason === 0 || mappedReason === '0') return '';
        return mappedReason;
    };

    return (
        <BaseModel closeModal={props.closeModal}>
            <ParentDiv>
                <TitleView>Profile State History</TitleView>
                {stateHistory && stateHistory.length > 0 ? stateHistory.map((item, pos) => {
                    const displayReason = getDisplayReason(item);
                    return (
                <div key={pos}>
                            <FlexWrapperCenter>
                                <TextView>{getDateWithTime(item.time)}</TextView>
                                <GapView width="20px" />
                                <TextView className="width50Percent">
                                    {item.curator}
                                </TextView>
                                <GapView width="20px" />
                                <TextView>{item.profile_state || item.name}{item.hive_action_context ? ` (${item.hive_action_context})` : (displayReason ? ` (${displayReason})` : '')}</TextView>
                            </FlexWrapperCenter>
                            <LineView />
                        </div>
                    );
                }) : (
                    <TextView small style={{marginTop: '20px'}}>No state history available</TextView>
                )}
            </ParentDiv>
        </BaseModel>
    )
}

export default ProfileStateListModal
